import { render, staticRenderFns } from "./genFinalResults.vue?vue&type=template&id=30cb59d9&"
import script from "./genFinalResults.vue?vue&type=script&lang=js&"
export * from "./genFinalResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports